import type { Environment } from '@prisma/client';
import type { RecorderCommand } from '~/common/recorder/recorder-operation';
import type { VmServerToClientMessage } from '~/common/vm/protocol';
import type { RecorderExecutionType } from '~/common/vm/shared-types';
import type { RecorderInitiatorLocation } from '~/server/logic/recorder/recorder-types';
import { useRecorderClientWeb } from './use-recorder-client-web';

// In case of image, it's a mjpeg (basically a video)
export type MediaSource = { type: 'video'; track: MediaStreamTrack } | { type: 'image'; src: string };

export type RecorderStartArgs = {
  recorderInitiatorLocation?: RecorderInitiatorLocation;
  antiBot?: boolean;
  useProxy?: boolean;
  environment?: Environment;
};

export type RecorderClientHook = {
  start: (args: RecorderStartArgs) => Promise<void>;
  close: () => Promise<void>;
  send: (command: RecorderCommand) => void;
  mediaSource?: MediaSource;
  viewport?: { width: number; height: number };
};

export type RecorderClientParams = {
  testContentId: string;
  executionType: RecorderExecutionType;
  messageHandler: MessageHandler;
};

export type MessageHandler = ({
  message,
  close,
  sendServerCommand,
}: {
  message: VmServerToClientMessage;
  close: () => void;
  sendServerCommand: (message: RecorderCommand) => void;
}) => void;

// Purpose is to multiplex between different recorder clients
export const useRecorderClient = (params: RecorderClientParams): RecorderClientHook => {
  const recorderClientWeb = useRecorderClientWeb(params);

  return recorderClientWeb;
};
